export default (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_FILTERS':
      return {
        ...state,
        ...action.payload
      };
    case 'CLEAR_FILTERS':
      return {
        ...state,
        ...action.payload
      };
    case 'SAVE_TICKETS_FILTERS':
      return {
        ...state,
        tickets: action.filters
      };
    case 'CLEAR_TICKETS_FILTERS':
      return {
        ...state,
        tickets: ''
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/filters-reducer.js